export default {
  somarTodos(valor, valorTotal) {
    return valor + valorTotal
  }
}
